export const exportUrls = {
  user: {
    csv: 'api/myPortfolio/generateByUserCSV',
    pdf: 'api/myPortfolio/generateByUserPdf',
  },
  project: {
    csv: 'api/myPortfolio/generateByProjectCSV',
    pdf: 'api/myPortfolio/generateByProjectPdf',
  },
};

export const fetchTimeLogsLeadTypeMap = {
  projectILead: 'project',
  workstreamILead: 'workstream',
  all: 'all',
};

export const dropdownUrls = {
  user: {
    all: 'api/reports/getAllByAssignee',
    projectILead: 'api/reports/getProjectILeadByAssignee',
    workstreamILead: 'api/reports/getWorkStreamILeadByAssignee',
  },
  project: {
    all: 'api/reports/getAllByProject',
    projectILead: 'api/reports/getProjectILeadByProject',
    workstreamILead: 'api/reports/getWorkStreamILeadByProject',
  },
};

export const exportModalId = 'exportMyPortfolioLogs';
export const fetchUserTimeLogUrl = 'api/myPortfolio/getUserTimeLog';
export const fetchProjectUserListUrl = 'api/myPortfolio/getUserList';
export const fetchProjectListUrl = 'api/myPortfolio/getByProject';
export const fetchUserListUrl = 'api/myPortfolio/getByUser';
export const maxPerPage = 20;
